CustomerAccountMembershipsController.$inject = ["API_URL", "$http", "$q", "$timeout", "$rootScope", "$filter"];
angular.module('calendarApp').controller('CustomerAccountMembershipsController', CustomerAccountMembershipsController);

function CustomerAccountMembershipsController(API_URL, $http, $q, $timeout, $rootScope, $filter) {
  var member = this,
      throbber = $rootScope.throbber;
  member.timeSettings = smooth.timeSettings;

  var init = function init() {
    throbber.show();
    $http.get(API_URL + '/api/v1/calendar/customer/membership').then(function (_ref) {
      var response = _ref.data;
      throbber.hide();

      if (!response.success) {
        var msg = $filter('calendarLabel')('Sorry but there was an error with this request: ') + response.msg;
        throbber.showError(msg);
        return;
      }

      member.memberships = response.memberships;
    }).catch(function (err) {
      throbber.showError("Sorry but an error has occurred: ".concat(err.message));
    });
  };

  init();

  member.cancelMembership = function (membershipID) {
    if (!confirm("Please confirm that you'd like to delete this membership. Your membership will remain active until the end of the billing cycle but you will not be billed again.")) return;
    throbber.show();
    $http.put(API_URL + "/api/v1/calendar/membership/delete/".concat(membershipID)).then(function (_ref2) {
      var response = _ref2.data;
      if (!response.success) return throbber.showError("Sorry but an error occurred with this request: ".concat(response.msg));
      throbber.hide("Your membership has been cancelled successfully");
      $timeout(function () {
        init();
      }, 2000);
    }).catch(function (err) {
      throbber.showError("Sorry but an error has occurred: ".concat(err.message));
    });
  };

  member.toggleHistory = function (membershipid) {
    $("#membership-transaction-history-table-".concat(membershipid)).slideUp('slow');
    $("#membership-history-table-".concat(membershipid)).slideToggle('slow');
  };

  member.toggleTransactionHistory = function (membershipid) {
    $("#membership-history-table-".concat(membershipid)).slideUp('slow');
    $("#membership-transaction-history-table-".concat(membershipid)).slideToggle('slow');
  };
}